import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react'

import { prepareDefaultHeaders } from '../../api'

// Rooted at the apiserver (not `/i/`) so a feature's public reads and `/i/` writes share one cache.
export const internalApiserverApi = createApi({
  reducerPath: 'internalApiserverApi',
  baseQuery: fetchBaseQuery({
    baseUrl: window.GR_API_URLS.API_URL_CORE + '/',
    prepareHeaders: prepareDefaultHeaders,
  }),
  // Read in one file and written in another.
  tagTypes: [
    'internalCategories',
    'internalCategoryFeatures',
    'internalFeatures',
    'internalTags',
    'internalConcepts',
    'internalBulkAssignScreenshots',
    'internalImplementationScreenshots',
  ],
  endpoints: () => ({}),
})

// Reads of a category's features live in several files; every feature write of the category invalidates this.
export const categoryFeaturesTag = (categoryId: string) => ({ type: 'internalCategoryFeatures' as const, id: categoryId })
